import { Query } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { OrderListState, OrderListStore } from './order-list.store';
import {TableColumn} from '../../models/table-column';
import {getOrderFilterOptions, getTableColumns} from './order-table-columns';
import {ISavedListSettingsQuery} from '../../interfaces/settings/saved-list-settings.query';
import {state} from '@angular/animations';

@Injectable({
  providedIn: 'root',
})
export class OrderListQuery extends Query<OrderListState> implements ISavedListSettingsQuery {
  columns$;
  filterOptions$;
  filterValue$;

  constructor(protected store: OrderListStore) {
    super(store);

    this.columns$ = this.select((state) => state.columns);
    this.filterOptions$ = this.select((state) => state.filterOptions);
    this.filterValue$ = this.select((state) => state.filterValue);
  }

  filterOptions(): any {
    return this.store.getValue()?.filterOptions;
  }

  getFilterColumns(): TableColumn[] {
    return null;
  }

  getInitialColumns(): TableColumn[] {
    return getTableColumns();
  }

  getTableColumns(): TableColumn[] {
    return this.store.getValue()?.columns;
  }

  newFilterStructure(): boolean {
    return false;
  }

  getInitialFilter(): any {
    return getOrderFilterOptions();
  }

  hasFilter(): boolean {
    return true;
  }
}
